<script setup>
import { HButton, HCol, HDropdown, HProfile } from '@pixul/hephaestus';
import NavbarItem                             from '@/components/Navbar/NavbarItem.vue';
</script>

<template>
  <HDropdown
    class='navbar-profile'
    position='bottom-right'
  >
    <template #activator='{ activatorClick }'>
      <HButton plain>
        <HProfile
          :username='userName'
          @click='activatorClick'
        />
      </HButton>
    </template>
    <template #default='{ closeDropdown }'>
      <HCol>
        <template
          v-for='item in items'
          :key='item.name'
        >
          <NavbarItem
            v-if='!item.hide'
            :class='`navbar-item--${ item.name }`'
            :item='item'
            @click='closeDropdown'
          />
        </template>
      </HCol>
    </template>
  </HDropdown>
</template>

<script>
import { mapStores }        from 'pinia';
import { useUserStore }     from '@/store/user';
import { useLanguageStore } from '@/store/language';

export default {
  name : 'NavbarProfile',

  props : {
    items : {
      type    : Array,
      default : () => []
    }
  },

  computed : {
    ...mapStores(useUserStore, useLanguageStore),

    userName() {

      return `${this.userStore.user.firstName } ${ this.userStore.user.lastName}`;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar-profile {
  .c-button.c-button--normal {
    padding: 0;
    border-radius: 100%;
  }
}

.navbar-item--report-bug :deep(.navbar-item--hover) {
  svg, p {
    color: var(--yellow);
  }
}
</style>